/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import "jspdf-autotable";
import SchoolContext from "../../../Context/SchoolContext";
import TableHeader from "../../Common/TableHeader";
import Loader from "../../Common/Loader";
import Pagination from "../../Common/Pagination";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import * as XLSX from "xlsx";
import Select from "react-select";
import PrintBoothDormantForm from "./PrintBoothDormantForm";

function BoothDormantAccounts() {

    const [modal, setModal] = useStateCallback(false);
    const {schoolList} = useContext(SchoolContext);
    const [query, setQuery] = useState("");
    const [school, setSchool] = useState("");
    const [endDate, setEndDate] = useState("");
    const [startDate, setStartDate] = useState("");
    const [boothDormantList, setBoothDormantList] = useState([]);
    const [page, setPage] = useState(1);
    const [meta, setMeta] = useState("");
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [first, setFirst] = useState("");
    const [printableList, setPrintableList] = useState([]);

    useEffect(() => {
        if (query || school || startDate || endDate) {
          searchStudentList();
        }else {
          getStudentList(page);
        }
    }, [page]);

    const getStudentList = async () => {
        setBoothDormantList([]);
        setLoading(true);
        const server_response = await ajaxStudent.listAllBoothDormantStudents(page);
        setLoading(false);
        if (server_response.status === "OK") {
          setFirst(server_response.details.meta.offset);
          setMeta(server_response.details.meta.totalPages);
          setBoothDormantList(server_response.details.data || []);
        } else {
          setBoothDormantList([]);
        }
      };
    
      const searchStudentList = async (e) => {
        if (e) {
          e.preventDefault();
        }
        setLoading2(true);
        const server_response = await ajaxStudent.searchAllBoothDormantStudents(page, school, startDate, endDate, query);
        setLoading2(false);
        if (server_response.status === "OK") {
          setFirst(server_response.details.meta.offset);
          setMeta(server_response.details.meta.totalPages);
          setBoothDormantList(server_response.details.data || []);
        } else {
          setBoothDormantList([]);
        }
    };

    const resetSearch = () => {
        setQuery("");
        setSchool("");
        setStartDate("");
        setEndDate("");
        setPage(1);
        getStudentList(1); 
    };

    const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const handleModal = () => {
    setModal(false, () =>
      setModal(
        <PrintBoothDormantForm
          g={setPrintableList}
          h={exportToExcel}
          printableList={printableList}
          isOpen={true}
        />
      )
    );
  };

  const handleStudentChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    setPage(1);
    if (value === '') {
      resetSearch(e);
    }
  }

  const exportToExcel = (data) => {
        const worksheetData = (data || []).map((item) => ({
          "Names": item.user,
          "Username":item.username,
          "School": item.school,
          "Class": item.group,
          "Buzztime Credit": item.buzztime_balance,
          "Account Status":item.is_secure ===1?"-":item.default_pin
         }));
      
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Booth Dormant Accounts");
      
        XLSX.writeFile(workbook, "booth_dormant_accounts_list.xlsx");
  };

  return (
    <>
      {modal}
     
      <div class="heading-layout1 mg-b-5">
        <TableHeader
          subtitle="List of all activated student accounts that have not made any communication using the booths."    
        />
        <div class="dropdown">
          <Link class="dropdown-toggle" role="button" 
          data-toggle="dropdown" aria-expanded="false">...</Link>
          <div class="dropdown-menu dropdown-menu-right">
            <Link class="dropdown-item" onClick={handleModal}><i class="fas fa-file-export"></i>Export</Link>

          </div>
        </div>
      </div>

      <form className="mg-t-20" onSubmit={searchStudentList}>
      <div className="row gutters-5">
        <div className="col-9-xxxl col-lg-9 col-12 form-group">
          <div className="row">
          <div className="col-lg-4 mt-2">
              <input
                type="text"
                placeholder="Enter first or last name..."
                style={{ border: "1px solid grey" }}
                value={query}
                onChange={handleStudentChange}
                className="form-control"
              />
            </div>
            <div className="col-lg-3 mt-2">
              <Select
                onChange={(e) => setSchool(e ? e.school_id : "")}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_id}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                  school === ""
                    ? null
                    : Array.isArray(schoolList) &&
                      schoolList.find((value) => value.school_id === school)
                }
              />
            </div>
            <div className="col-lg-5">
              <div className="flex-fill position-relative">
                <div className="input-group input-daterange" id="datepicker">
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="start date"
                  />
                  <span
                    className="input-group-text"
                    style={{
                      marginLeft: "-1px",
                      borderTopLeftRadius: "0",
                      borderTopRightRadius: "0",
                      borderBottomLeftRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    to
                  </span>
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="form-control"
                    placeholder="end date"
                  />
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <div className="col-3-xxxl col-lg-3 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={resetSearch}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini mt-2"
          >
            RESET
          </button>
        </div>
      </div>
    </form>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
        {loading || loading2 ? (
          <Loader /> 
        ) : (
          <table className="table display data-table text-nowrap">
                      <thead>
                          <tr>
                          <th scope="col">No.</th>
                          <th scope="col">Student Name</th>
                          <th scope="col"> School</th>
                          <th scope="col">Class</th>
                            <th scope="col">Activation Date</th>
                         <th scope="col">Buzztime Credit</th>
                          <th scope="col"> Account Status</th>
                          
                          </tr>
                      </thead>
                      <tbody>
                          {boothDormantList.length > 0 ? (
                              boothDormantList.map((item, index) => (
                              <tr key={index}>
                                  
          
                                  <td>{index + first + 1} </td>
                                  
                                  <td><Link to={`/students/profile/${item.student_id}/${item.user_id}`}>{item.user}</Link></td>
                                  
          
                                  <td>{item.school}</td>
                                  <td>{item.group}</td>
                                  <td>{item.activation_date?.short_date}</td>
                                  <td>UGX. {item.buzztime_balance}</td>
                                  <td>{item.is_secure===1?<span class="badge badge-success">SECURED</span>:
                                                    <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip id="refresh-tooltip">Account is not secure!</Tooltip>}>
                                                        <span class="badge badge-danger">{item.default_pin}</span></OverlayTrigger>}
                                                </td>
          
                              </tr>
                              ))
                          ) : (
                              <tr>
                                  <td colSpan="6" style={{ textAlign: "center" }}>
                                      No dormant (booth) accounts.
                                  </td>
                              </tr>
                          )}
                      </tbody>
                  </table>
        )}
      </div>

      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>

    </>
     
  
  );
}

export default BoothDormantAccounts;
